export const percent = (used: number, max: number) =>
  Math.min(100, Math.max(0.5, Number(((used / max) * 100).toFixed(4))));
